import { FormEvent } from 'react'
import { useForm, Link } from '@inertiajs/react'
import AuthLayout from '@/components/layouts/AuthLayout'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import MuiLink from '@mui/material/Link'

export default function Register() {
  const { data, setData, post, processing, errors } = useForm({
    user: {
      email: '',
      password: '',
      password_confirmation: '',
    },
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post('/users')
  }

  return (
    <AuthLayout title="Create Account">
      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
        <TextField
          label="Email"
          type="email"
          fullWidth
          margin="normal"
          value={data.user.email}
          onChange={(e) => setData('user', { ...data.user, email: e.target.value })}
          error={!!errors['user.email']}
          helperText={errors['user.email']}
          autoFocus
        />
        <TextField
          label="Password"
          type="password"
          fullWidth
          margin="normal"
          value={data.user.password}
          onChange={(e) => setData('user', { ...data.user, password: e.target.value })}
          error={!!errors['user.password']}
          helperText={errors['user.password']}
        />
        <TextField
          label="Password Confirmation"
          type="password"
          fullWidth
          margin="normal"
          value={data.user.password_confirmation}
          onChange={(e) => setData('user', { ...data.user, password_confirmation: e.target.value })}
          error={!!errors['user.password_confirmation']}
          helperText={errors['user.password_confirmation']}
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          size="large"
          disabled={processing}
          sx={{ mt: 2, mb: 2 }}
        >
          Sign Up
        </Button>
        <Box sx={{ textAlign: 'center' }}>
          <MuiLink component={Link} href="/users/sign_in" underline="hover">
            Already have an account? Sign in
          </MuiLink>
        </Box>
      </Box>
    </AuthLayout>
  )
}
